import React from 'react';
import './Notification.css';

const WelcomeModal = ({ open, userName, newCount, onClose }) => {
  if (!open) return null;
  return (
    <div className="notification-modal-overlay">
      <div className="notification-modal">
        <h2>Bonjour {userName} !</h2>
        <p>
          Depuis votre dernière connexion, il y a <b>{newCount}</b> nouvel{newCount > 1 ? 's' : ''} article{newCount > 1 ? 's' : ''} publié{newCount > 1 ? 's' : ''}.
        </p>
        <button className="notification-modal-close" onClick={onClose}>Fermer</button>
      </div>
    </div>
  );
};

export default WelcomeModal;
